const PRERENDER_UNTIL_SCRIPT_ORIGIN_TRIAL_TOKEN =
	'A/VAet/bEjA4ln7DXeiHQE7cBUrzS4f9Qz45yc8fguKgPEio2/c/rEzqRnIPfbgp49o+M2MFkhRKy9Z7LKGPowUAAACLeyJvcmlnaW4iOiJodHRwczovL3N0YXRpYy5wYXJhc3RvcmFnZS5jb206NDQzIiwiZmVhdHVyZSI6IlByZXJlbmRlclVudGlsU2NyaXB0IiwiZXhwaXJ5IjoxNzg4ODI1NjAwLCJpc1N1YmRvbWFpbiI6dHJ1ZSwiaXNUaGlyZFBhcnR5Ijp0cnVlfQ=='

const experiments = window.viewerModel?.experiments || {}

if (experiments['specs.thunderbolt.usePrerenderUntilScript']) {
	const tokenElement = document.createElement('meta')
	tokenElement.httpEquiv = 'origin-trial'
	tokenElement.content = PRERENDER_UNTIL_SCRIPT_ORIGIN_TRIAL_TOKEN
	document.head.appendChild(tokenElement)
}
